import * as React from 'react';
const UiConfigContext = /*#__PURE__*/ React.createContext(null);
export function useUiConfig() {
    return React.useContext(UiConfigContext);
}
export const UiConfigProvider = ({ config, children })=>{
    const parentConfig = useUiConfig();
    const mergedConfig = React.useMemo(()=>({
            ...parentConfig !== null && parentConfig !== void 0 ? parentConfig : {},
            ...config
        }), [
        parentConfig,
        config
    ]);
    return /*#__PURE__*/ React.createElement(UiConfigContext.Provider, {
        value: mergedConfig
    }, children);
};

//# sourceMappingURL=UiConfigProvider.js.map